import type { SVGProps } from 'react';

export default function AppleGlyph({ width = 18, height = 18, className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width={width}
      height={height}
      className={className}
      fill="currentColor"
      aria-hidden="true"
      {...rest}
    >
      <path d="M14.91 9.578c-.022-2.337 1.91-3.464 2-3.519-1.087-1.587-2.78-1.804-3.385-1.83-1.443-.146-2.819.85-3.553.85-.745 0-1.871-.83-3.077-.806-1.583.023-3.043.92-3.86 2.337-1.645 2.853-.42 7.073 1.187 9.39.785 1.135 1.722 2.412 2.952 2.366 1.18-.048 1.626-.766 3.054-.766 1.428 0 1.825.766 3.078.74 1.27-.022 2.075-1.16 2.852-2.298.9-1.317 1.273-2.595 1.295-2.66-.029-.013-2.482-.952-2.543-3.804zM12.65 2.86c.652-.79 1.09-1.886.97-2.978-.939.038-2.075.625-2.748 1.412-.604.7-1.131 1.815-.99 2.886 1.045.082 2.114-.531 2.768-1.32z" />
    </svg>
  );
}
